const links: { path: string; name: string }[] = [
  { path: 'dashboard', name: 'Overview' },
  { path: 'stories/preview', name: 'Stories' },
  { path: 'authors/preview', name: 'Contributors' },
  { path: 'value', name: 'Content Value' },
  { path: 'value/stories', name: 'Story Level' },
];

export default links;
